import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LayoutRoutes from './LayoutRoutes'
import PrivateRoutes from './PrivateRoutes';
import SignIn from '../Auth';
import { AuthProvider } from '../Contexts/AuthContext';
import UserProvider from '../Contexts/UserContext';
import { AppProvider } from '../Contexts/AppContext';
import ForgotPassword from '../Auth/forgotPassword';
import ResetPassword from '../Auth/resetPassword';

export default function Routers() {
    const token = localStorage.getItem("token");

    return (
        <AuthProvider>
            <AppProvider>
                <UserProvider>
                    <BrowserRouter basename={'/'}>
                        <Routes>
                            {token ? (
                                <>
                                    <Route path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                                    <Route path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                                </>
                            ) : (
                                ""
                            )}
                            <Route path={"/"} element={<PrivateRoutes />}>
                                <Route path={`/*`} element={<LayoutRoutes />} />
                            </Route>
                            <Route path={`${process.env.PUBLIC_URL}/login`} element={<SignIn />} />
                            <Route path={`${process.env.PUBLIC_URL}/forgot-password`} element={<ForgotPassword />} />
                            <Route path={`${process.env.PUBLIC_URL}/reset-password`} element={<ResetPassword />} />
                        </Routes>
                    </BrowserRouter>
                </UserProvider>
            </AppProvider>
        </AuthProvider>
    )
}